import { Accordion, AccordionDetails, AccordionSummary, Box, FormControl, IconButton, InputAdornment, InputLabel, List, ListItem, ListItemText, OutlinedInput, Popover, Typography } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import React, { FC, memo, useEffect, useState } from 'react'
import { HardwareType } from '../../api/appAPI'
import Item, { LinkType } from '../../classes/Item'
import { Shift } from '../common/Helpers'
import { makeHardwareList } from './HardwareComponent'
import { appConfig } from '../../config'
import { useWeightUnit } from '../../hooks/useUnit'
import { kgToLbs } from '../common/UnitComponents'


interface IProps {
    item: Item
    hardwareList: Array<HardwareType>
    open: boolean
    isAdmin: boolean
    isDemo: boolean

    addHardwareToItem(itemName: string, hId: number): void
    deleteHardwareFromItem(itemName: string, hId: number): void
    addOpenItem(itemName: string): void
    removeOpenItem(itemName: string): void
    addLink(itemName: string, link: LinkType): void
    setItemAddon(itemName: string, d: number, p: number): void
    setHardwareCount(itemName: string, localId: number, count: number): void
    setParamCountHardwarePerCM(itemName: string, localId: number, perCM: number): void
    openHardwareDetails(hId: number): void
}

const ItemComponent: FC<IProps> = (props) => {

    const formatPrice = (price: string) => {
        const _price = parseFloat(price) * (props.isDemo ? Math.PI : 1)
        return _price.toFixed(appConfig.fractionDigits)
    }

    const { unit: weightUnit } = useWeightUnit()

    const [hardwareSelectOpen, setHardwareSelectOpen] = useState(false)
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)
    const [price, setPrice] = useState(formatPrice(props.item.getPrice()))
    const [clearPrice, setClearPrice] = useState(formatPrice(props.item.getClearPrice()))
    const [nonMarkupPrice, setNonMarkupPrice] = useState(formatPrice(props.item.getNonMarkupPrice()))
    const [openChildrenName, setOpenChildrenName] = useState<string[]>([])
    const [weight, setWeight] = useState(props.item.getWeight())

    useEffect(() => {
        setItemPrice()
    })

    const setItemPrice = () => {
        setPrice(formatPrice(props.item.getPrice()))
        setClearPrice(formatPrice(props.item.getClearPrice()))
        setNonMarkupPrice(formatPrice(props.item.getNonMarkupPrice()))
        setWeight(props.item.getWeight())
    }
    // debugger
    return (<>
        <Accordion
            style={{ background: '#cfe2f3', marginBottom: 10 }}
            expanded={props.open}
            TransitionProps={{ unmountOnExit: true }}
        >
            <AccordionSummary
                style={{ cursor: 'default' }}
                expandIcon={
                    <ExpandMoreIcon style={{ cursor: 'pointer' }} onClick={() => {
                        if (props.open)
                            props.removeOpenItem(props.item.name)
                        else
                            props.addOpenItem(props.item.name)
                    }} />
                }
            >
                <Box display='flex' alignItems='center' width='100%' style={{ columnGap: 5 }}>

                    <Typography>{props.item.name.split('$$')[0]}</Typography>

                    <Shift />

                    {/* <FormControl variant="outlined" size='small'>
                        <InputLabel>Add On</InputLabel>
                        <OutlinedInput
                            style={{ width: 100 }}
                            type='number'
                            label='Add On'
                            value={props.item.addon.dollar}
                            onChange={(e) => {
                                const value = parseFloat(e.target.value)
                                props.setItemAddon(props.item.name, value, props.item.addon.percentage)
                            }}
                            startAdornment={<InputAdornment position="start">$</InputAdornment>}
                            inputProps={{ min: 0 }}
                        />
                    </FormControl>
                    <FormControl variant="outlined" size='small'>
                        <InputLabel>Add On</InputLabel>
                        <OutlinedInput
                            style={{ width: 100 }}
                            type='number'
                            label='Add On'
                            value={props.item.addon.percentage}
                            onChange={(e) => {
                                const value = parseFloat(e.target.value)
                                props.setItemAddon(props.item.name, props.item.addon.dollar, value)
                            }}
                            startAdornment={<InputAdornment position="start">%</InputAdornment>}
                            inputProps={{ min: 0 }}
                        />
                    </FormControl> */}
                    <Box width={100} textAlign='end' sx={{ mr: 2 }}>
                        <Typography>{weightUnit === 'kg' ? weight : kgToLbs(parseFloat(weight))} {weightUnit}</Typography>
                    </Box>
                    {(props.isAdmin || props.isDemo) && <><Box width={100} textAlign='end' >
                        <Typography>${clearPrice}</Typography>
                    </Box>
                        <Box width={100} textAlign='end' >
                            <Typography>${nonMarkupPrice}</Typography>
                        </Box></>}
                    <Box width={100} textAlign='end' sx={{ mr: 2 }}>
                        <Typography>${price}</Typography>
                    </Box>
                </Box>
            </AccordionSummary>
            <AccordionDetails >
                <Box
                    style={{
                        width: '100%',
                        height: '100%'
                    }}
                // p={2}
                >

                    <Box
                        style={{
                            // width: '100%',
                            // height: '100%',
                            background: '#e9f5f3',
                            border: '1px solid black',
                            borderRadius: 7
                        }}
                        p={2}
                    >
                        <Box display='flex'>
                            <Typography variant='h6'>Parts</Typography>
                            <Shift />
                            <IconButton onClick={(e) => {
                                setHardwareSelectOpen(true)
                                setAnchorEl(e.currentTarget)
                            }}>
                                <AddIcon />
                            </IconButton>
                        </Box>
                        <Box mt={2}>
                            {makeHardwareList(props.item, props.item.hardwares, (localId: number) => { props.deleteHardwareFromItem(props.item.name, localId) }, props.addLink, setItemPrice, props.setHardwareCount, props.setParamCountHardwarePerCM, props.openHardwareDetails)}
                        </Box>
                    </Box>
                    {props.item.children.length > 0 && <Box
                        style={{
                            background: '#e6bb7c',
                            borderRadius: 7
                        }}
                        mt={2}
                        p={2}
                    >
                        <Box display='flex'>
                            <Typography variant='h6'>Children</Typography>
                        </Box>
                        <Box mt={2}>
                            {props.item.children.map(childItem =>
                                <ItemComponent key={childItem.name}
                                    {...{
                                        ...props,
                                        item: childItem,
                                        open: openChildrenName.includes(childItem.name),
                                        addOpenItem: (name: string) => { setOpenChildrenName([...openChildrenName, name]) },
                                        removeOpenItem: (name: string) => { setOpenChildrenName(openChildrenName.filter(n => n !== name)) }
                                    }}
                                />)}
                        </Box>
                    </Box>}
                </Box>
            </AccordionDetails>
        </Accordion>
        <Popover
            open={hardwareSelectOpen}
            anchorEl={anchorEl}
            onClose={() => { setHardwareSelectOpen(false) }}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
        >
            <List style={{ minWidth: 250 }}>
                {props.hardwareList.map(h => <ListItem
                    key={h.id}
                    button
                    onClick={() => {
                        props.addHardwareToItem(props.item.name, h.id)
                        setHardwareSelectOpen(false)
                    }}>
                    <ListItemText primary={h.name} />
                </ListItem>
                )}
            </List>
        </Popover>
    </>
    )
}


interface ICabinetProps {
    addonD: number
    addonP: number
    clearPrice: number
    nonMarkupPrice: number
    price: number
    isAdmin: boolean
    weight: string

    setAddonD(value: number): void
    setAddonP(value: number): void
}

export const CabinetItemComponent: FC<ICabinetProps> = (props) => {
    const { unit: weightUnit } = useWeightUnit()

    return (
        <Accordion
            style={{ background: '#9ac9f3', marginBottom: 10 }}
            expanded={false}
        >
            <AccordionSummary
                style={{ cursor: 'default' }}
            // expandIcon={<ExpandMoreIcon />}
            >
                <Box display='flex' alignItems='center' width='100%' style={{ columnGap: 5 }}>

                    <Typography>Cabinet</Typography>

                    <Shift />

                    <FormControl variant="outlined" size='small'>
                        <InputLabel>Add On</InputLabel>
                        <OutlinedInput
                            style={{ width: 100 }}
                            type='number'
                            label='Add On'
                            value={props.addonD}
                            onChange={(e) => {
                                const value = parseFloat(e.target.value)
                                props.setAddonD(isNaN(value) ? 0 : value)
                            }}
                            startAdornment={<InputAdornment position="start">$</InputAdornment>}
                            inputProps={{}}
                        />
                    </FormControl>
                    <FormControl variant="outlined" size='small'>
                        <InputLabel>Add On</InputLabel>
                        <OutlinedInput
                            style={{ width: 100 }}
                            type='number'
                            label='Add On'
                            value={props.addonP}
                            onChange={(e) => {
                                const value = parseFloat(e.target.value)
                                props.setAddonP(isNaN(value) ? 0 : value)
                            }}
                            startAdornment={<InputAdornment position="start">%</InputAdornment>}
                            inputProps={{}}
                        />
                    </FormControl>
                    <Box width={100} textAlign='end' mr={4}>
                        <Typography>{weightUnit === 'kg' ? props.weight : kgToLbs(parseFloat(props.weight))} {weightUnit}</Typography>
                    </Box>
                    <Box width={100} textAlign='end'>
                        {props.isAdmin && <Typography>${props.clearPrice.toFixed(appConfig.fractionDigits)}</Typography>}
                    </Box>
                    <Box width={100} textAlign='end'>
                        {props.isAdmin && <Typography>${((props.nonMarkupPrice + props.addonD) + (props.nonMarkupPrice + props.addonD) * props.addonP / 100).toFixed(appConfig.fractionDigits)}</Typography>}
                    </Box>
                    <Box width={100} textAlign='end' mr={4}>
                        <Typography>${((props.price + props.addonD) + (props.price + props.addonD) * props.addonP / 100).toFixed(appConfig.fractionDigits)}</Typography>
                    </Box>
                </Box>
            </AccordionSummary>
        </Accordion>
    )
}

export default memo(ItemComponent)